export interface ReportModel {
    reportAutoID: number,
    reportID: string,
    reportName: string,
    progress: boolean,
    isActive: number,
    isScheduled: boolean,
    workspaceID: string,
    workspaceName: string,
    webUrl: string,
    embedUrl: string,
    datasetId: string,
    datasetWorkspaceId: string,
    createdBy: number,
    createdAt: string,
    processing: boolean,
    errorMsg: string
}

export interface GetReportParams {
    emailId: string | null,
    userID: number | null
}

export interface ReportDistributionModel {
    reportDistributionID: number,
    reportID: string,
    distributionName: string,
    distributionSchedule: string,
    distributionUsers: string,
    isActive: number,
    nextRunAt: any,
    lastRunAt: any,
    lastStatus: any,
    lastErrorMessage: any,
    createdBy: number,
    createdAt: any,
    format: string,
    progress: ProgressType
}

export enum ProgressType {
    None, Save, Deleting, DeleteStart
}

export interface DistributionLogModel {
    status: "success" | "fail";
    timestamp: string;
    message: string;
    description: string;
}

export interface ColumnRestrictionFilter {
    columnRestrictionId: number, columns: string | null, users: string | null, name: string | null
}


export interface ColumnRestrictionGroup {
    byUser: number;
    columnRestrictionId: number;
    name: string;
    users: string[];
    restrictedColumns: string[];
}


export interface RequestColumnAccessDto {
    byUser: number;
    userId: number;
    columnName: string;
    reason: string;
}

export interface AdminProcessRequestDto {
    requestId: number;
    adminUserId: number;
    userId: number; // Added to identify the user being reassigned
    status: "Approved" | "Rejected";
    adminNotes?: string;
    assignToGroupId?: number; // The exact match group ID selected by the admin
}

export interface ColumnAccessRequest {
    requestId: number;
    userId: number;
    columnName: string;
    requestDate: string;
    reason: string;
    status: "Pending" | "Approved" | "Rejected";
    adminNotes?: string;
}

export interface UpdateRequestStatusDto {
    requestId: number;
    status: "Approved" | "Rejected";
    adminNotes?: string;
}

export interface AddRestrictionColumnRequest {
    name: string;
}

export interface RestrictionColumnModel {
    id: string;
    name: string;
}

export type UserDataPreviewResponse = Record<string, string[]>;